import PatientUpdateRegisterFormContainer from './PatientUpdateRegisterFormContainer';

export default PatientUpdateRegisterFormContainer;
